import {
  Button,
  DestructiveIcon,
  Flex,
  Modal,
  ModalFooter,
  ModalTitle,
} from '@modusign/design-system';
import { useCallback, useState } from 'react';

import useResponsiveValue from '@app/hooks/useResponsiveValue';

import ContractLinkAgreementCheck from '../../types/ContractLinkAgreementCheck';
import ContractLinkAgreementCheckKey from '../../types/ContractLinkAgreementCheckKey';
import ContractLinkCreateInfoDesktopContent from './ContractLinkCreateInfoDesktopContent';
import ContractLinkCreateInfoMobileContent from './ContractLinkCreateInfoMobileContent';
import ContractLinkCreateSubmitButton from './ContractLinkCreateSubmitButton';

export interface ContractLinkCreateInfoModalProps {
  signerId: string;
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

function ContractLinkCreateInfoModal({
  signerId,
  isOpen,
  onClose,
  onSubmit,
  isLoading,
}: ContractLinkCreateInfoModalProps) {
  const [agreements, setAgreements] = useState<ContractLinkAgreementCheck>({
    linkParticipantSign: false,
    linkUsageDeduct: false,
  });

  const submitDisabled = Object.values(agreements).includes(false);

  const handleChecksChange = useCallback(
    (check: { name: ContractLinkAgreementCheckKey; value: boolean }) => {
      setAgreements({ ...agreements, [check.name]: check.value });
    },
    [agreements]
  );

  const ContractLinkCreateInfoContent = useResponsiveValue([
    ContractLinkCreateInfoMobileContent,
    ContractLinkCreateInfoDesktopContent,
  ]);

  return (
    <>
      <Modal isOpen={isOpen} maxWidth="md" px={0} onClose={onClose}>
        <ModalTitle icon={<DestructiveIcon color="iconPrimaryBase" />} mx="auto">
          링크서명 정보
        </ModalTitle>
        <Flex justifyContent="center" position="relative" textAlign="center" width="100%">
          <ContractLinkCreateInfoContent
            agreements={agreements}
            signerId={signerId}
            onCheckChange={handleChecksChange}
          />
        </Flex>
        <ModalFooter>
          <Button onClick={onClose}>취소</Button>
          <ContractLinkCreateSubmitButton
            disabled={submitDisabled}
            isLoading={isLoading}
            onClick={onSubmit}
          />
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ContractLinkCreateInfoModal;
